module.exports = __webpack_public_path__ + "static/media/totalCriticalRolesIcon.f941327c.svg";